import React, { createContext } from 'react'
import { Component } from 'react'

export const AppContext = createContext()

class AppContextProvider extends Component {

    constructor(props){
        super(props);

        this.state = {
            isUserLogged: localStorage.getItem("user_logged"),
            setUserLogged: (e) => this.setUser(e),
            userStep: 1,
            setUserStep: (e) => this.setUserStep(e)
        }
    }

    setUser(value){
        this.setState({
            isUserLogged: value
        })
    }

    setUserStep(value){
        this.setState({
            userStep: value
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.isUserLogged !== prevState.isUserLogged) {
            localStorage.setItem("user_logged", this.state.isUserLogged)
        }
        if (this.state.userStep !== prevState.userStep) {
            this.setState({
                userStep: this.state.userStep
            })
        }
    }

    render(){
        return (
            <AppContext.Provider value={this.state}>
                {this.props.children}
            </AppContext.Provider>
        )
    }
}

export default AppContextProvider